export default {
  JobClassificationServiceInterface: Symbol('JobClassificationServiceInterface'),
  IPageService: Symbol('IPageService'),
  IHelpMessageService: Symbol('IHelpMessageService'),
  EmployeeServiceInterface: Symbol('EmployeeServiceInterface'),
  FirmRoleServiceInterface: Symbol('FirmRoleServiceInterface'),
};
